/**
 * App functions are used for reaching the endpoints for accessing app data.
 * @module App
 * @since 0.0.7
 */
import GlobalFunctions from '../global'

module.exports = {
	/**
	 * Call to unoapp API that returns a list of apps.
	 * @function
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.7
	 */
	getApps () {
		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/list',
				data: {},
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/controllers/App.js